import { render, staticRenderFns } from "./config-attr.vue?vue&type=template&id=5eadcbae&scoped=true"
import script from "./config-attr.vue?vue&type=script&lang=js"
export * from "./config-attr.vue?vue&type=script&lang=js"
import style0 from "./config-attr.vue?vue&type=style&index=0&id=5eadcbae&prod&lang=scss&scoped=true"
import style1 from "./config-attr.vue?vue&type=style&index=1&id=5eadcbae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eadcbae",
  null
  
)

export default component.exports